<template lang="pug">
  include ./../../mixins 

  slick(
    ref="slick"
    :options="options"
  )
    slot(name="slide")
</template>

<script>
  import Slick from "vue-slick"
  export default {
    components: {
      Slick
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      arrow: {
        type: Boolean
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Slider/UiSlider.vue